import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateUserGroupSlice = getBulkActionSlice(
    'updateUserGroupResult',
);

export const selectUpdateUserGroupUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.updateUserGroupResult.uuid;

export const selectUpdateUserGroupShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.updateUserGroupResult.shown;

export const selectUpdateUserGroupTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.updateUserGroupResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = updateUserGroupSlice.actions;
